import { useMemo } from 'react';
import { usePostHog } from 'posthog-js/react';
import { PostHogInstance } from 'shared/posthogCapture/types';

export const createDocumentDisplayCaptureEvents = (
  posthog: PostHogInstance
) => ({
  downloaded: () => {
    posthog?.capture('doc display / downloaded');
  },
  jumpedToPage: () => {
    posthog?.capture('doc display / jumped to page');
  },
  openedFullscreen: () => {
    posthog?.capture('doc display / opened fullscreen');
  },
  shared: () => {
    posthog?.capture('doc display / shared');
  },
  toggledOpen: () => {
    posthog?.capture('doc display / toggled open');
  },
});

export type DocumentDisplayCaptureEvents = ReturnType<
  typeof createDocumentDisplayCaptureEvents
>;

export const usePosthogCapture = () => {
  const posthog = usePostHog();
  return useMemo(() => createDocumentDisplayCaptureEvents(posthog), [posthog]);
};
